import { useCallback, useEffect, useState } from 'react';
import { apiCall, default as API_CONFIG } from '../config/api';

/**
 * Latest market-regime snapshot, `days` of indicator history, and the
 * indicator definitions (labels, Russ's reading of each). One request.
 */
export const useMarketRegime = (days = 120) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    apiCall(API_CONFIG.endpoints.marketRegime(days))
      .then((res) => { if (!cancelled) setData(res || null); })
      .catch((err) => {
        if (cancelled) return;
        console.error('Failed to load market regime', err);
        setError('Failed to load market regime');
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [days, version]);

  const reload = useCallback(() => setVersion((v) => v + 1), []);
  return { data, loading, error, reload };
};

/** POST /market-regime/refresh -- recompute the trailing two weeks now. */
export const refreshMarketRegime = () =>
  apiCall(API_CONFIG.endpoints.marketRegimeRefresh, { method: 'POST' });

/** POST /market-regime/rebuild -- backfill `days` of history. */
export const rebuildMarketRegime = (days = 365) =>
  apiCall(API_CONFIG.endpoints.marketRegimeRebuild(days), { method: 'POST' });
